import { AddressSearch, AddressSearchApi, partialMatchRegex, Search, ZipCodeSearch } from 'Services';

const notifyChangeToInput = (inputElement: HTMLInputElement) => {
  const event = new Event('change', { bubbles: true });
  inputElement.dispatchEvent(event);
};

const setFieldValue = (nodeElement: NodeListOf<HTMLElement>, value: string) => {
  if (nodeElement.length === 0 || !(nodeElement.item(0) instanceof HTMLInputElement)) return;

  const inputElement: HTMLInputElement = nodeElement.item(0) as HTMLInputElement;
  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
  setter?.call(inputElement, value);
  notifyChangeToInput(inputElement);
};

const sliceValueUntilPatternMatch = (value: string, pattern: string | undefined) => {
  while (value.length > 0 && pattern && !partialMatchRegex(new RegExp(pattern)).test(value)) {
    value = value.slice(0, -1);
  }

  return value;
};

const setFields = (selectedSearch: Search, pattern?: string) => {
  if (AddressSearchApi.isInstanceOfAddressSearch(selectedSearch)) {
    setAddressFields(selectedSearch as AddressSearch, pattern);
  } else if (AddressSearchApi.isInstanceOfZipCodeSearch(selectedSearch)) {
    setRelatedZipCodeFields(selectedSearch as ZipCodeSearch);
  }
};

const setRelatedZipCodeFields = (selectedSearch: ZipCodeSearch) => {
  const cityNode = document.getElementsByName('city');
  setFieldValue(cityNode, selectedSearch.name);

  const addressNode = document.getElementsByName('postalAddress');
  const additionalAddressNode = document.getElementsByName('custom_address2');

  [addressNode, additionalAddressNode].forEach((node) => {
    if (node.length === 0 || !(node.item(0) instanceof HTMLInputElement)) return;
    const inputElement: HTMLInputElement = node.item(0) as HTMLInputElement;
    inputElement.removeAttribute('readOnly');
    inputElement.removeAttribute('disabled');
  });
};

const unsetRelatedZipCodeFields = () => {
  const addressNode = document.getElementsByName('postalAddress');
  const additionalAddressNode = document.getElementsByName('custom_address2');
  const cityNode = document.getElementsByName('city');
  setFieldValue(cityNode, '');

  [addressNode, additionalAddressNode].forEach((node) => {
    if (node.length === 0 || !(node.item(0) instanceof HTMLInputElement)) return;
    const inputElement: HTMLInputElement = node.item(0) as HTMLInputElement;
    inputElement.setAttribute('readOnly', 'true');
    inputElement.setAttribute('disabled', 'true');
  });
};

const setAddressFields = (selectedSearch: AddressSearch, pattern?: string) => {
  const addressSearch = selectedSearch as AddressSearch;
  const zipCodeNode = document.getElementsByName('postalCode');
  setFieldValue(zipCodeNode, addressSearch.zipCode);
  const addressNode = document.getElementsByName('postalAddress');
  const value = sliceValueUntilPatternMatch(
    `${addressSearch.streetNumber ?? ''}${addressSearch.additionalStreetNumber ?? ''} ${addressSearch.streetName}`.trim(),
    pattern,
  );

  if (!value) return;

  setFieldValue(addressNode, value);
  const cityNode = document.getElementsByName('city');
  setFieldValue(cityNode, addressSearch.city);
  const additionalAddressNode = document.getElementsByName('custom_address2');
  addressSearch.additionalAddress && setFieldValue(additionalAddressNode, addressSearch.additionalAddress);
};

const validateAddress = (postalAddress: string, postalCode: string, city: string) =>
  AddressSearchApi.fetchAddressValidation(postalAddress, postalCode, city);

export const AutocompletionService = {
  setFields,
  validateAddress,
  unsetRelatedZipCodeFields,
};
